import React from 'react';
import PropTypes from 'prop-types';
import QuickSearchAutosuggest from '@Containers/QuickSearchAutosuggest';
import useStaticExamplesEnabled from '@Pages/QuickSearch/Components/BuildQuery/useStaticExamplesEnabled';
import wrapWithStaticExamples from '@Pages/QuickSearch/Components/RxSearchLabel/wrapWithStaticExamples';
import RxSearchLabel from '../../RxSearchLabel';

import './BuildQuerySearch.scss';
import SearchTips from '../SearchTips/SearchTips';

const QuickSearchAutosuggestWithStaticExamples = wrapWithStaticExamples(QuickSearchAutosuggest);

function BuildQuerySearch(props) {
  const { query, populateQuickSearch, updateInputText, searchByQuery } = props;
  const isStaticExamplesEnabled = useStaticExamplesEnabled();
  const handleKeyDown = (e) => {
    if (e.keyCode !== 13 || !e.target?.value || e.target?.value.trim() === '') {
      return;
    }
    searchByQuery();
  };

  return (
    <div className="build-query-search">
      <SearchTips updateInputText={updateInputText} />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="id-quick-search-input" className="c-els-field__label">
        Search Reaxys
      </label>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div role="search" aria-label="Search reaxys properties" className="build-query-search__input" onKeyDown={handleKeyDown}>
        {isStaticExamplesEnabled ? (
          <QuickSearchAutosuggestWithStaticExamples
            inputValue={query.text}
            buildQuery={{ updateInputText, query }}
            onChange={updateInputText}
          />
        ) : (
          <QuickSearchAutosuggest inputValue={query.text} buildQuery={{ updateInputText, query }} onChange={updateInputText} />
        )}
      </div>
      {!isStaticExamplesEnabled ? <RxSearchLabel onSuffixClick={populateQuickSearch} /> : null}
    </div>
  );
}

BuildQuerySearch.propTypes = {
  query: PropTypes.object,
  populateQuickSearch: PropTypes.func.isRequired,
  updateInputText: PropTypes.func.isRequired,
  searchByQuery: PropTypes.func.isRequired,
};

export default BuildQuerySearch;
